// App-facing class advice: binds the bundled genTokens.json forceable-token set
// to the pure functions in classAdvice.js. Import THIS from components; the pure
// module is for tests (same split as simCalibration / simCalibrationLive).
import genTokens from '../data/genTokens.json';
import {
  classAdvice as classAdvicePure,
  avoidPicks as avoidPicksPure,
  classFullAdvice as classFullAdvicePure,
  makeForceable,
} from './classAdvice.js';

const FORCEABLE = makeForceable(genTokens);

export const classAdvice = (rosterStats, cls, opts = {}) => classAdvicePure(rosterStats, cls, { forceable: FORCEABLE, ...opts });
export const avoidPicks = (rosterStats, cls, opts = {}) => avoidPicksPure(rosterStats, cls, { forceable: FORCEABLE, ...opts });
export const classFullAdvice = (rosterStats, cls, opts = {}) => classFullAdvicePure(rosterStats, cls, { forceable: FORCEABLE, ...opts });

// These don't touch the forceable set — re-exported for a one-stop import.
export { genderEdge, HIDDEN_SKILLS } from './classAdvice.js';
